import {connect} from 'react-redux';

import RequestSpinner from './request-spinner';

export default connect(state => state.requestSpinner)(RequestSpinner);
